import { useEffect } from 'react';
import {
    useShowRecommendedWarning,
    useShowRequiredWarning,
} from 'newport/store/hooks';
import { useAppSelector } from 'store/hooks';
import { selectNewportVersionDetails } from 'newport/store/newportAppSlice';
import { useDispatchShowNotification } from 'notification/store/dispatcher';
import { NotificationType } from '@instinet-analytics/semantic-ui-components';

export function useNewportAppRecommendedVersionNotification() {
    const showRequiredWarning = useShowRequiredWarning();
    const showRecommendedWarning = useShowRecommendedWarning();
    const versionDetails = useAppSelector(selectNewportVersionDetails);
    const dispatchNotification = useDispatchShowNotification();

    useEffect(() => {
        if (showRequiredWarning) {
            // Banner will be shown for required, so don't need a notification as well
            return;
        }
        if (!showRecommendedWarning) {
            return;
        }
        if (!versionDetails) {
            return;
        }

        const text = `Newport version warning: your version ${versionDetails.clientNewportVersion} is below the recommended version ${versionDetails.minRecommendedNewportVersion}`;

        dispatchNotification(text, NotificationType.Info);
    }, [
        dispatchNotification,
        showRecommendedWarning,
        showRequiredWarning,
        versionDetails,
    ]);
}
